import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));
const DetailPage = lazy(() => import("./Pages/Detail"));
const DetailSchedule = lazy(() => import("./Pages/InterviewSchedule/Detail"));

export const evaluationRoutes = [
  {
    page: MainPage,
    path: pathRoutes.evaluation.base,
    screenCode: SCREEN.IP_025,
  },
  {
    page: MainPage,
    path: pathRoutes.evaluation.parameter,
    screenCode: SCREEN.IP_025,
  },
  {
    page: DetailPage,
    path: pathRoutes.evaluation.detail.parameter,
    screenCode: SCREEN.IP_025,
  },
  {
    page: DetailSchedule,
    path: `${pathRoutes.evaluation.base}${pathRoutes.evaluation.tabs.schedule}/:scheduleId`,
    screenCode: SCREEN.IP_026,
  },
];
